/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerCheckStatusQueryResponse,
  TelegramTransactionsUserControllerCheckStatusQueryParams,
  TelegramTransactionsUserControllerCheckStatus401,
} from '../../types/TelegramTransactionsUserControllerCheckStatus.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramTransactionsUserCheckStatus } from '../../methods/telegramTransactionsUserCheckStatus.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramTransactionsUserCheckStatusQueryKey = (
  params: TelegramTransactionsUserControllerCheckStatusQueryParams,
) => [{ url: '/api/user/telegram/transactions/check-status' }, ...(params ? [params] : [])] as const;

export type TelegramTransactionsUserCheckStatusQueryKey = ReturnType<
  typeof telegramTransactionsUserCheckStatusQueryKey
>;

export function telegramTransactionsUserCheckStatusQueryOptions(
  params: TelegramTransactionsUserControllerCheckStatusQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramTransactionsUserCheckStatusQueryKey(params);
  return queryOptions<
    TelegramTransactionsUserControllerCheckStatusQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerCheckStatus401>,
    TelegramTransactionsUserControllerCheckStatusQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramTransactionsUserCheckStatus(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/transactions/check-status}
 */
export function useTelegramTransactionsUserCheckStatus<
  TData = TelegramTransactionsUserControllerCheckStatusQueryResponse,
  TQueryData = TelegramTransactionsUserControllerCheckStatusQueryResponse,
  TQueryKey extends QueryKey = TelegramTransactionsUserCheckStatusQueryKey,
>(
  params: TelegramTransactionsUserControllerCheckStatusQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramTransactionsUserControllerCheckStatusQueryResponse,
        ResponseErrorConfig<TelegramTransactionsUserControllerCheckStatus401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramTransactionsUserCheckStatusQueryKey(params);

  const query = useQuery(
    {
      ...telegramTransactionsUserCheckStatusQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramTransactionsUserControllerCheckStatus401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
